"use client";

import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components"
import { Box, Column } from "@motorata/base-ui.components.atoms._atoms";
import Button from "@motorata/base-ui.components.atoms.button";
import Modal from "@motorata/base-ui.components.molecules.modal";
import { P, Title } from "@motorata/base-ui.components.atoms.typography";
import { translateBrand, translateModel } from "@motorata/base-ui.data";
import { SentryService } from "@motorata/base-ui.services.sentry-service";
import Link from "@motorata/next.components.atoms.link";
import EmptyBlock from "../../components/shared/EmptyBlock"
import OfferBlock, { OfferBlockLoader } from "../../components/shared/OfferBlock"
import { UserService } from "@/services/UserService";
import AccountEditOffer from "@/views/account/AccountEditOffer";

const AccountOffers = () => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])

  const [offerToDelete, setOfferToDelete] = useState(null)
  const [offerToEdit, setOfferToEdit] = useState(null)
  const [deleting, setDeleting] = useState(false)

  const fetchData = useCallback(async () => {
    try {
      setLoading(true)
      // @ts-ignore
      const { content } = await UserService.getOffers()
      setData(content)
    } catch (e) {
      console.log("[ERROR UserService.getOffers API]", e)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchData()
  }, [])

  const handleOnDelete = useCallback(async () => {
    try {
      setDeleting(true);
      await UserService.deleteOffer(offerToDelete?.id);
      setOfferToDelete(null)
      fetchData()
    } catch (e) {
      SentryService.error("[ERROR UserService.deleteOffer API]", e);
    } finally {
      setDeleting(false);
    }
  }, [offerToDelete])

  const renderEmptyComponent = useCallback(() => {
    return (
      <Column padding="60px 30px" justifyContent="center" alignItems="center">
        <EmptyBlock text="Dodaj swoje pierwsze ogłoszenie" />
        <Link icon="plus" href="/konto/dodaj-ogloszenie" marginTop="S">
          Dodaj ogłoszenie
        </Link>
      </Column>
    )
  }, [])

  return (
    <>
      <Title label="Panel">Twoje ogłoszenia</Title>
      <Wrapper>
        {!loading && data?.length === 0 && renderEmptyComponent()}
        {loading && (
          <>
            <OfferBlockLoader />
            <OfferBlockLoader />
            <OfferBlockLoader />
          </>
        )}
        {!loading && data?.map(offer => (
          <OfferWrapper key={offer.id}>
            <OfferBlock
              offer={offer}
            />
            <OfferButtons>
              <Button type="secondary" icon="pen" onClick={() => setOfferToEdit(offer)}>
                Edytuj
              </Button>
              <Button icon="trash" background="red" hoverBackground="red" onClick={() => setOfferToDelete(offer)}>
                Usuń
              </Button>
            </OfferButtons>
          </OfferWrapper>
        ))}
      </Wrapper>
      <Modal
        title="Edytuj ogłoszenie"
        show={!!offerToEdit}
        type="side"
        maxWidth="950px"
        setShow={setOfferToEdit}
      >
        {offerToEdit && <AccountEditOffer offer={offerToEdit} handleSubmit={() => {
          setOfferToEdit(false)
          fetchData()
        }} />}
      </Modal>
      <Modal
        title="Usuń ogłoszenie"
        type="center"
        maxWidth="350px"
        show={!!offerToDelete}
        setShow={setOfferToDelete}
      >
        <Box>
          <P textAlign="center">Czy na pewno chcesz usunąć ogłoszenie <span>{translateBrand(offerToDelete?.brand)} {translateModel(offerToDelete?.model)}</span>?</P>
          <OfferDeleteButtons>
            <Button type="secondary" width="100%" onClick={() => setOfferToDelete(null)}>
              Nie
            </Button>
            <Button
              width="100%"
              background="red"
              hoverBackground="red"
              loading={deleting}
              margin="0 0 10px"
              onClick={handleOnDelete}
            >
              Tak
            </Button>
          </OfferDeleteButtons>
        </Box>
      </Modal>
    </>
  )
}

export default AccountOffers

const OfferDeleteButtons = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${({ theme }) => theme.space.XS};
  `;

const OfferButtons = styled(Box)`
  padding: ${({ theme }) => theme.space.XS};
  border-radius: ${({ theme }) => theme.variable.borderRadius};
  background: white;
  border: 1px solid ${({ theme }) => theme.color.fourth};
  display: flex;
  justify-content: flex-end;
  grid-gap: ${({ theme }) => theme.space.XS};
  `;

const OfferWrapper = styled(Box)`
  
  `;

const Wrapper = styled(Box)`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${({ theme }) => theme.space.S};
`
